import "./App.css";
import axios from "axios";
import React, { useState, useEffect } from "react";
import renderHTML from "html-react-parser";
import sortObjectsArray from "sort-objects-array";

function App() {
  const [allFroms, setAllForms] = useState([]);
  const [displayForms, setDisplayForms] = useState([]);
  const COMPETING_GRANT_APPLICATIONS = "Competing Grant Applications";
  const PROGRESS_REPORTS = "Post-Award Reporting";
  const FORMAT_PAGES = "Format Pages";
  const SMALL_BUSINESS = "Small Business";
  const FELLOWSHIPS_TRAINING = "Fellowships and Training";
  const ADMINISTRATIVE_CHANGE = "Administrative - Change of Grantee";
  const LOAN_REPAYMENT_PROGRAMS = "Loan Repayment Programs";
  const POST_AWARD = "Post-Award";
  const ALL = "All";
  const [activeTags, setActiveTags] = useState("All");
  const [displayView, setDisplayView] = useState("table");
  const [sortType, setSortType] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [see, setSee] = useState(true);
  const [scope_note, setScope] = useState([]);
  const SERVER = "https://grants.nih.gov/__extra/app-FORMS";

  useEffect(() => {
    axios.get(SERVER + "/data/card-display.json").then((res) => {
      let obj = {};
      res.data.map((item) => {
        switch (item.title) {
          case "COMPETING_GRANT_APPLICATIONS":
            obj.COMPETING_GRANT_APPLICATIONS = item.body;
            break;
          case "PROGRESS_REPORTS":
            obj.PROGRESS_REPORTS = item.body;
            break;
          case "FORMAT_PAGES":
            obj.FORMAT_PAGES = item.body;
            break;
          case "SMALL_BUSINESS":
            obj.SMALL_BUSINESS = item.body;
            break;
          case "FELLOWSHIPS_TRAINING":
            obj.FELLOWSHIPS_TRAINING = item.body;
            break;
          case "ADMINISTRATIVE_CHANGE":
            obj.ADMINISTRATIVE_CHANGE = item.body;
            break;
          case "LOAN_REPAYMENT_PROGRAMS":
            obj.LOAN_REPAYMENT_PROGRAMS = item.body;
            break;
        }
      });
      setScope(obj);
    });
  }, []);

  useEffect(() => {
    axios
      .get("https://grants.nih.gov/grants/forms/all-forms-export.json")
      .then((res) => {
        let raw_data = res.data;
        let final_data = [];
        raw_data.map((data) => {
          let search_tags = data.form_name.split(" ");

          let other_tags = data.field_search_tag_forms
            .replace(/\s+/g, " ")
            .trim();

          let converted_tags = [];
          search_tags.map((item) => {
            if (item !== "") {
              converted_tags.push(item.toUpperCase());
            }
          });
          let form_num = data.form_number.replaceAll("-", " ");

          if (form_num !== "") {
            converted_tags.push(form_num);
          }
          let obj = {
            number: data.form_number,
            name: data.form_name,
            nid: data.nid,
            url: data.view_node,
            tags: [],
            search: converted_tags,
            extra_tags: other_tags,
          };
          raw_data = data.field_main_category.split("|");
          raw_data.map((item) => {
            switch (item) {
              case "Manage a Small Business Award":
                obj.tags.push(SMALL_BUSINESS);
                break;
              case "Manage Fellowship":
                obj.tags.push(FELLOWSHIPS_TRAINING);
                break;
              case "Administrative - Change of Grantee":
                obj.tags.push(ADMINISTRATIVE_CHANGE);
                break;
              case "Competing Grant Applications":
                obj.tags.push(COMPETING_GRANT_APPLICATIONS);
                break;
              case "Submit a New or Renewal Application":
              case "Format Pages":
                if (!obj.tags.includes(FORMAT_PAGES)) {
                  obj.tags.push(FORMAT_PAGES);
                }
                break;
              case "Report on a Grant Award":
              case "Progress Reports":
                if (!obj.tags.includes(PROGRESS_REPORTS)) {
                  obj.tags.push(PROGRESS_REPORTS);
                }
                break;
              case "Loan Repayment Programs":
                obj.tags.push(LOAN_REPAYMENT_PROGRAMS);
                break;
            }
          });

          final_data.push(obj);
        });
        setAllForms(final_data);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has("filter")) {
          if (urlParams.get("filter") !== "") {
            switch (urlParams.get("filter")) {
              case "competing-grant-applications":
                changeActiveTags(COMPETING_GRANT_APPLICATIONS);
                break;
              case "post-award-reporting":
                changeActiveTags(PROGRESS_REPORTS);
                break;
              case "format-pages":
                changeActiveTags(FORMAT_PAGES);
                break;
              case "small-business":
                changeActiveTags(SMALL_BUSINESS);
                break;
              case "fellowships-training":
                changeActiveTags(FELLOWSHIPS_TRAINING);
                break;
              case "administrative-change":
                changeActiveTags(ADMINISTRATIVE_CHANGE);
                break;
              case "post-award":
                changeActiveTags(PROGRESS_REPORTS);
                break;
              case "lrp":
                changeActiveTags(LOAN_REPAYMENT_PROGRAMS);
                break;
              default:
                changeActiveTags(ALL);
            }
          } else {
            setDisplayForms(final_data);
          }
        } else {
          setDisplayForms(final_data);
        }

        setLoaded(true);
      });
  }, []);

  let changeActiveTags = (tag) => {
    if (tag) {
      setActiveTags(tag);
      setSee(true);
      tag = tag.replaceAll(" ", "_");
      if (document.getElementById(tag + "_menunav")) {
        document.getElementById(tag + "_menunav").style.display = "none";
      }
      if (tag == ALL) {
        window.history.replaceState(null, null, window.location.pathname);
      }
    }
  };
  let changeDisplayView = (type) => {
    setDisplayView(type);
  };

  let mobFormType = (e) => {
    changeActiveTags(e.target.value);
  };

  let sortNames = () => {
    let currentType = sortType;
    if (sortType == "") {
      currentType = "desc";
    }
    let newType = "";
    if (currentType === "asc") {
      newType = "desc";
    } else {
      newType = "asc";
    }
    setSortType(newType);
    let sorted = sortObjectsArray(displayForms, "name", newType);
    setDisplayForms(sorted);
  };

  let changeSee = () => {
    setSee(!see);
  };

  let scopeNote = (tag) => {
    switch (tag) {
      case "Competing Grant Applications":
        return scope_note.COMPETING_GRANT_APPLICATIONS;
      case "Post-Award Reporting":
        return scope_note.PROGRESS_REPORTS;
      case "Format Pages":
        return scope_note.FORMAT_PAGES;
      case "Small Business":
        return scope_note.SMALL_BUSINESS;
      case "Fellowships and Training":
        return scope_note.FELLOWSHIPS_TRAINING;
      case "Administrative - Change of Grantee":
        return scope_note.ADMINISTRATIVE_CHANGE;
      case "Loan Repayment Programs":
        return scope_note.LOAN_REPAYMENT_PROGRAMS;
    }
    return "All";
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    if (activeTags === "All") {
      setDisplayForms(allFroms);
    } else {
      let forms = [];
      allFroms.map((form) => {
        let TagCheck = form.tags.filter((item) => item == activeTags);
        if (TagCheck.length > 0) {
          forms.push(form);
        }
      });
      setDisplayForms(forms);

      let new_filter = "";
      switch (activeTags) {
        case COMPETING_GRANT_APPLICATIONS:
          new_filter = "competing-grant-applications";
          break;
        case POST_AWARD:
        case PROGRESS_REPORTS:
          new_filter = "post-award-reporting";
          break;
        case FORMAT_PAGES:
          new_filter = "format-pages";
          break;
        case SMALL_BUSINESS:
          new_filter = "small-business";
          break;
        case FELLOWSHIPS_TRAINING:
          new_filter = "fellowships-training";
          break;
        case ADMINISTRATIVE_CHANGE:
          new_filter = "administrative-change";
          break;
        case LOAN_REPAYMENT_PROGRAMS:
          new_filter = "lrp";
          break;

        default:
          new_filter = "All";
      }
      url.searchParams.set("filter", new_filter);
      window.history.pushState({ path: url.href }, "", url.href);
    }
  }, [activeTags]);

  let reset = () => {
    setActiveTags("All");
  };

  let hoverNav = (tag) => {
    if (!activeTags.includes(tag)) {
      tag = tag.replaceAll(" ", "_");
      document.getElementById(tag + "_menunav").style.display = "block";
      document.getElementById(tag + "_menunav").style.width = "80%";
      document.getElementById(tag + "_menunav").style.height = "10px";
      tag === "All"
        ? (document.getElementById(tag + "_menunav").style.borderBottom =
            "2px solid black")
        : (document.getElementById(tag + "_menunav").style.borderBottom =
            "2px solid white");
    }
  };

  let dishoverNav = (tag) => {
    tag = tag.replaceAll(" ", "_");
    document.getElementById(tag + "_menunav").style.display = "none";
  };

  let searchForm = (e) => {
    setActiveTags("All");
    let term = e.target.value;
    let finalOutput = [];
    allFroms.map((item) => {
      if (
        item.name.toLowerCase().indexOf(term.toLowerCase()) !== -1 ||
        item.number.toLowerCase().indexOf(term.toLowerCase()) !== -1 ||
        item.extra_tags.toLowerCase().indexOf(term.toLowerCase()) !== -1
      ) {
        finalOutput.push(item);
      }
    });
    setDisplayForms(finalOutput);
  };

  return (
    <div className="App">
      <div className="header-wrapper">
        <div className="header-title">Filter by Form Category</div>
        <div className="form-display-options-wrapper">
          {[
            ALL,
            COMPETING_GRANT_APPLICATIONS,
            PROGRESS_REPORTS,
            FORMAT_PAGES,
            SMALL_BUSINESS,
            FELLOWSHIPS_TRAINING,
            ADMINISTRATIVE_CHANGE,
            LOAN_REPAYMENT_PROGRAMS,
          ].map((tag, index) => {
            return (
              <div
                key={index + "anbc"}
                className={
                  activeTags.includes(tag)
                    ? "form-option-card selected-card"
                    : "form-option-card"
                }
                tabIndex="0"
                onClick={() => {
                  changeActiveTags(tag);
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    changeActiveTags(tag);
                  }
                }}
              >
                <div className="tagname">{tag}</div>
                <div id={tag.replaceAll(" ", "_") + "_menunav"}></div>
                <div id="empty_menunav"></div>
              </div>
            );
          })}
        </div>

        {activeTags != "All" &&
        scopeNote(activeTags) &&
        scopeNote(activeTags).trim() != "" ? (
          <div className="d-flex mt-4 mb-4">
            <div className="d-flex flex-column">
              <small className="bg-secondary bi bi-pencil-fill d-flex p-1 rounded-circle text-white"></small>
              <div className="d-flex h-100 justify-content-around mt-1 mx-2">
                <div className="bg-secondary h-100" style={{ width: "3px" }}></div>
              </div>
            </div>
            <div className="ps-3">
              <strong>{activeTags}</strong>
              <div>
                {" "}
                {see ? (
                  scopeNote(activeTags) ? (
                    renderHTML(scopeNote(activeTags))
                  ) : (
                    ""
                  )
                ) : (
                  <div className="see-more" onClick={changeSee}>
                    See More
                  </div>
                )}
                {see ? (
                  <div className="see-less" onClick={changeSee}>
                    See Less
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="view-option-wrapper">
        <div className="search-forms-wrapper">
          <span>Search All by Form Name or Number</span>
          <input
            type="text"
            onChange={searchForm}
            placeholder="Biographical Sketch, SBIR"
          />
        </div>
        <div className="option-holder">
          <div
            className={
              displayView === "card" ? "card-view active-view" : "card-view"
            }
            onClick={() => {
              changeDisplayView("card");
            }}
          >
            <div tabIndex="0">Card View</div>
          </div>
          <div
            className={
              displayView === "table" ? "table-view active-view" : "table-view"
            }
            onClick={() => {
              changeDisplayView("table");
            }}
          >
            <div tabIndex="0">Table View</div>
          </div>
        </div>
      </div>

      <div
        className="form-display-wrapper"
        style={{ display: displayView === "card" ? "flex" : "none" }}
      >
        {displayForms.length > 0 ? (
          displayForms.map((form, index) => {
            return (
              <div className="form-display-card" key={index + "asd"}>
                <div className="form-name">
                  <a href={form.url}>{renderHTML(form.name)}</a>
                </div>
                {form.number && form.number !== "" ? (
                  <div className="form-number">
                    {" "}
                    <strong>Form Number: </strong>
                    {renderHTML(form.number)}
                  </div>
                ) : (
                  ""
                )}
                <div className="category">
                  <i class="bi bi-tag-fill"></i>
                  <div className="ms-1">
                    {form.tags
                      ? form.tags.map((tag, i) => {
                          return i == form.tags.length - 1 ? tag : tag + ", ";
                        })
                      : ""}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <>
            {loaded ? (
              "No results found"
            ) : (
              <div className="lds-roller-wrapper">
                <div className="lds-roller">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <div
        className="form-table-wrapper"
        style={{ display: displayView === "table" ? "block" : "none" }}
      >
        <table className="form-table">
          <tr>
            <th style={{ width: "40%" }}>
              Form Name{" "}
              <div className="sortIcon" onClick={sortNames}>
                {sortType === "" ? (
                  <i class="bi bi-caret-up-fill"></i>
                ) : sortType === "desc" ? (
                  <i class="bi bi-caret-down-fill"></i>
                ) : (
                  <i class="bi bi-caret-up-fill"></i>
                )}
              </div>
            </th>
            <th>Form Number</th>
            <th>Form Category</th>
          </tr>
          {displayForms.length > 0 ? (
            displayForms.map((form, index) => {
              return (
                <tr key={index}>
                  <td>
                    <a href={form.url}>{renderHTML(form.name)}</a>
                  </td>
                  <td>{form.number ? renderHTML(form.number) : ""}</td>
                  <td>
                    {" "}
                    <div className="category">
                      <i class="bi bi-tag-fill"></i>
                      <div className="ms-1">
                        {form.tags
                          ? form.tags.map((tag, i) => {
                              return i == form.tags.length - 1
                                ? tag
                                : tag + ", ";
                            })
                          : ""}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <>
              {loaded ? (
                "No results found "
              ) : (
                <div className="lds-roller-wrapper">
                  <div className="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              )}
            </>
          )}
        </table>
      </div>
    </div>
  );
}

export default App;
